import { parseTree2Query } from "./parseTree2Query";
import { text2ParseTree } from "./text2ParseTree";

export const text2Query = (t: string) =>
  parseTree2Query(text2ParseTree(t.toLowerCase()));
